define('drops/calendarWeekView/calendarWeekView',[
    'jquery',
    'underscore',
    'globalize',
    'moment',
    'lq/constants',
    'lq/drop',
    'drops/calendar/calendarParameter',
    'drops/calendar/calendarItems',
    'lq/windowSize',
    'lq/nestingContext',
    'tpl!drops/calendarWeekView/calendarWeekView.html',
    'lq/onlongpress'
], function ($, _, globalize, moment, constants, Drop, calendarParameter, calendarItems, windowSize, NestingContext, template, OnLongPress) {
    'use strict';

    var defaults = {
        data: {
            dataSource: null,
            dataSourceType: 'datetimes',
            dateOutput: null,
            startOutput: null,
            endOutput: null,
            calendarStartParameter: 'CalendarWeekStart',
            calendarEndParameter: 'CalendarWeekEnd',
            timeslotSize: 30,
            dayStart: 0,
            dayEnd: (60 * 24) - 1,
            titleFormat: 'D',
            dayHeaderFormat: 'ddd, MMM dd',
            timeslotHourFormat: 'HH:mm',
            hideTitleEndDate: false
        },
        childDrops: [
            {
                data: { type: 'CalendarItem' }
            }
        ]
    };

    function CalendarWeekView(options) {
        Drop.call(this, $(template()), defaults, options);
        // right now we're not really doing anything with the selected date in the week view
        this.selectedDate = null;
    };

    Drop.extend(CalendarWeekView, Drop);

    CalendarWeekView.typeName = 'CalendarWeekView';

    CalendarWeekView.prototype.applyPosition = $.noop;

    CalendarWeekView.prototype.loadCalendarData = function () {
        if (!this.data.dataSource)
            return;

        var dateOfRequestedData = moment(this.date);

        var self = this;
        this.piping.queryDispatcher.backgroundDispatch(
            this.data.dataSource,
            function (response) {
                if (dateOfRequestedData.isSame(self.date))
                    self.showItems(response.Outputs, response.Results);
            });
    };

    CalendarWeekView.prototype.setSelectedDate = function (date) {
        this.selectedDate = date;
    };

    CalendarWeekView.prototype.clearSelectedDate = function () {
        this.selectedDate = null;
    };

    CalendarWeekView.prototype.getSelectedDate = function () {
        return this.selectedDate;
    };

    CalendarWeekView.prototype.init = function () {
        this.nestingContext = new NestingContext(this.piping);
        this.goToDefaultPosition();
    };

    CalendarWeekView.prototype.goToDefaultPosition = function () {
        if (!$.isNumeric(this.data.defaultScrollPosition)) return;

        var slotNumber = Math.floor((this.data.defaultScrollPosition - this.data.dayStart) / this.data.timeslotSize);
        var $slot = this.$hours.children('.timeslot').eq(slotNumber);
        this.$container.scrollTop(this.$container.scrollTop() + $slot.position().top);
    };

    CalendarWeekView.prototype.render = function () {
        this.registerForDataSource();
        this.prepareUi();
        this.createWeekdayHeaders();
        this.createWeekdayColumns();
        this.createTimeslots();
        this.open(moment());

        var self = this;
        _.each(this.$columns, function ($weekday, dayOfWeek) {
            if ($(self.$headers[dayOfWeek]).hasClass('today')) {
                $weekday.children().addClass('today');
            }
        });
    };

    CalendarWeekView.prototype.prepareUi = function () {
        this.$container = this.$element.find('.calendar-main');
        this.$title = this.$element.find('.date-as-title');
        this.$hours = this.$element.find('.hours');
        this.$weekdays = this.$element.find('.weekdays');
        this.$weekdayHeaders = this.$element.find('.weekday-headers');

        this.$backPage = this.$element.find('.previous-page');
        this.$nextPage = this.$element.find('.next-page');

        var self = this;
        this.$backPage
            .on('click', function () {
                self.previous();
            });
        this.$nextPage
            .on('click', function () {
                self.next();
            });

        windowSize.withOnChanged(this.updateHeadersWidth.bind(this));
    };

    CalendarWeekView.prototype.afterShown = function () {
        this.updateHeadersWidth();
        this.updateHeadersLeftMargin();
    };

    CalendarWeekView.prototype.createWeekdayHeaders = function () {
        this.$headers = _.map(_.range(0, 7), function () {
            return $('<div />')
                .addClass('weekday-header');
        });
        this.$weekdayHeaders.append(this.$headers);
    };

    CalendarWeekView.prototype.createWeekdayColumns = function () {
        this.$columns = _.map(_.range(0, 7), function () {
            return $('<div />')
                .addClass('weekday');
        });
        this.$weekdays.append(this.$columns);
    };

    CalendarWeekView.prototype.createTimeslots = function () {
        var timeslots = _.range(this.data.dayStart, this.data.dayEnd, this.data.timeslotSize);

        var self = this;
        _.each(this.$columns, function ($weekday, dayOfWeek) {
            var $timeslots = _.map(timeslots, function (startMinute) {
                var $slot = $('<div />')
                    .addClass('timeslot');
                new OnLongPress().applyLongPressOnElement($slot, self,
                    function(e) {
                        return self.determineEventArg(dayOfWeek, startMinute);
                    }, function() {
                        self.timeslotClicked(dayOfWeek, startMinute);
                    });

                $slot.on("mousedown", calendarItems.timeslotMousedown.bind(self, $weekday, dayOfWeek));
                $slot.on("mouseup", calendarItems.timeslotMouseup.bind(self));
                $slot.on("mousemove", calendarItems.timeslotMousemove.bind(self));

                return $slot;
            });
            $weekday.append($timeslots);
        });

        var $hours = _.map(timeslots, function (timeslot) {
            var date = new Date(1970, 0, 1);
            date.setMinutes(timeslot);

            return $('<div />')
                .addClass('timeslot')
                .text(globalize.format(date, self.data.timeslotHourFormat));
        });
        this.$hours
            .append($('<div class="calendar-header"></div>'))
            .append($hours);
    };

    CalendarWeekView.prototype.determineEventArg = function (dayOfWeek, startMinute) {
        var dateAndTime = moment(this.monday)
            .add(dayOfWeek, 'day')
            .add(startMinute, 'minute');
        return globalize.format(dateAndTime.toDate(), constants.licquidDateFormat);
    };

    CalendarWeekView.prototype.timeslotClicked = function (dayOfWeek, startMinute) {
        var eventArg = this.determineEventArg(dayOfWeek, startMinute);
        this.triggerEvent(this.data.eventing.clicked.raisedEventName, eventArg);
    };

    CalendarWeekView.prototype.registerForDataSource = function () {
        if (this.data.dataSource) {
            var self = this;
            this.piping.datasources.registerDatasourceListener(this.data.dataSource, function (data) {
                self.removeCalendarItems();
                self.showItems(data.Outputs, data.Results);
            });
        }
    };

    CalendarWeekView.prototype.previous = function () {
        this.open(moment(this.date).add(-1, 'week'));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarWeekView.prototype.next = function () {
        this.open(moment(this.date).add(1, 'week'));
        this.loadCalendarData();
        this.triggerNavigatedEvent();
    };

    CalendarWeekView.prototype.triggerNavigatedEvent = function () {
        this.triggerEventIfEnabled('navigated', this.getStartOfCurrentWeek());
    };

    CalendarWeekView.prototype.open = function (date) {
        this.date = date;

        this.monday = moment(this.date).startOf('isoWeek');
        this.sunday = moment(this.date).endOf('isoWeek');

        this.updateTitle();
        this.updateWeekdayHeaders();
        this.removeCalendarItems();
        this.updateHeadersWidth();
        this.updateHeadersLeftMargin();

        var parameters = this.piping.parameters;
        parameters.locals.setValue(this.data.calendarStartParameter, calendarParameter.convert(this.getStartOfCurrentWeek()));
        parameters.locals.setValue(this.data.calendarEndParameter, calendarParameter.convert(this.getEndOfCurrentWeek()));
    };

    CalendarWeekView.prototype.getStartOfCurrentWeek = function() {
        return moment(this.getOpenDate()).startOf('isoWeek');
    };

    CalendarWeekView.prototype.getEndOfCurrentWeek = function() {
        return moment(this.getOpenDate()).endOf('isoWeek');
    };

    CalendarWeekView.prototype.updateTitle = function () {
        if (!this.data.hideTitleEndDate) {
            var title = globalize.format(this.monday.toDate(), this.data.titleFormat) + ' - ' + globalize.format(this.sunday.toDate(), this.data.titleFormat);
        } else {
            var title = globalize.format(this.monday.toDate(), this.data.titleFormat);
        }
        this.$title.text(title);
    };

    CalendarWeekView.prototype.updateWeekdayHeaders = function() {
        var self = this;
        _.each(this.$headers, function ($header, i) {
            var date = moment(self.monday).add(i, 'days');
            var weekDayTitle = globalize.format(date.toDate(), self.data.dayHeaderFormat);
            $header.text(weekDayTitle);
            var today = moment();
            if (date.isSame(today, 'day')) {
                $header.addClass('today');
            }
        });
    };

    CalendarWeekView.prototype.updateHeadersWidth = function () {
        // WHY give the cells in the header row the same width as the weekday columns
        // this handles the appearance/dissapearance of a scrollbar
        var self = this;
        _.defer(function () {
            self.$weekdayHeaders.width(self.$weekdays.width());
        });
    };

    CalendarWeekView.prototype.updateHeadersLeftMargin = function () {
        // WHY mergin on the left should be equal to the width of the column that contains the hours
        var self = this;
        _.defer(function() {
            self.$weekdayHeaders.css('margin-left', self.$hours.outerWidth());
        });
    };

    CalendarWeekView.prototype.getOpenDate = function () {
        return this.date;
    };

    CalendarWeekView.prototype.showItems = function (outputs, rows) {
        var self = this;

        var startOfCurrentWeek = this.getStartOfCurrentWeek();
        var endOfCurrentWeek = this.getEndOfCurrentWeek();

        var items = _.chain(rows)
            .map(function(row) {
                var startOfItem = self.getDatetimeFromRow(row, self.data.startOutput);
                var endOfItem = self.getDatetimeFromRow(row, self.data.endOutput);
                var endClone = endOfItem.clone();
                var startClone = startOfItem.clone();

                var startIsBetween = startOfItem.isBetween(startOfCurrentWeek, endOfCurrentWeek, undefined, '[]');
                var endIsBetween = endOfItem.isBetween(startOfCurrentWeek, endOfCurrentWeek, undefined, '[]');

                var diff = 0;
                if (!startIsBetween || !endIsBetween) { // Multiweek case
                    diff = endClone.endOf('day').diff(startClone.startOf('day'), 'days') + 1;
                } else {
                    diff = endClone.isoWeekday() - startClone.isoWeekday() + 1;
                }

                return _.chain(_.range(diff))
                    .map(function (dayDifference) {
                        return moment(startOfItem).add(dayDifference, 'day');
                    })
                    .filter(function (dateTime) {
                        return (startOfCurrentWeek.isSame(dateTime) || startOfCurrentWeek.isBefore(dateTime))
                            && (endOfCurrentWeek.isSame(dateTime) || endOfCurrentWeek.isAfter(dateTime))
                            && (!moment(dateTime).startOf('day').isSame(endOfItem));
                    })
                    .map(function(dateTime) {
                        var startOfItemInCurrentDay = dateTime.isSame(startOfItem, 'day') ?
                            dateTime : moment(dateTime).startOf('day');
                        var endOfItemInCurrentDay = dateTime.isSame(endOfItem, 'day') ?
                            endOfItem : moment(dateTime).endOf('day');

                        var weekday = startOfItemInCurrentDay.isoWeekday() - 1;
                        var $weekday = self.$columns[weekday];

                        return $.extend(true, {}, self.childDrops[0], {
                            data: {
                                $target: $weekday,
                                startOfDay: moment(startOfItemInCurrentDay).startOf('day').add(self.data.dayStart, 'minutes'),
                                endOfDay: moment(endOfItemInCurrentDay).startOf('day').minutes(self.data.dayEnd),
                                startOfItem: startOfItemInCurrentDay,
                                endOfItem: endOfItemInCurrentDay,
                                row: row,
                                outputs: outputs,
                                eventArg: self.data.eventArg,
                                tooltipOutput: self.data.tooltipOutput,
                                idOutput: self.data.idOutput
                            }
                        });
                    })
                    .value();
            })
            .flatten()
            .value();

        calendarItems.fillUp(this, items)
            .then(function () {
                self.nestingContext.executeDataSources();
            }).catch(function (e) {
                self.piping.errorHandler.showErrorDialog(e);
            });
    };

    CalendarWeekView.prototype.removeCalendarItems = function () {
        _.each(this.pool, function (drop) {
            drop.$element.remove();
        });
        this.removeAllDrops();
    };

    CalendarWeekView.prototype.getDatetimeFromRow = function (row, output) {
        if (this.data.dataSourceType === 'datetimes')
            return moment(row[output]);

        var dateTime = moment(row[this.data.dateOutput]).startOf('day');
        var time = row[output];
        return dateTime.add(time, 'seconds');
    };

    return CalendarWeekView;
});

